module.exports = __webpack_public_path__ + "img/calendar.ea2c9ae4.svg";